import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import { useInvalidateWorkflowQuery } from "./use-workflow-query";
import { useInvalidateWorkflowListQuery } from "./use-workflows-query";

type UseUpdateWorkflowActivationParams = {
	shopId: string;
	workflowId: string;
};

export function useUpdateWorkflowActivation({
	shopId,
	workflowId,
}: UseUpdateWorkflowActivationParams) {
	const mutation = $api.useMutation(
		"patch",
		"/shops/{shopId}/workflows/{workflowId}",
	);
	const invalidateWorkflowListQuery = useInvalidateWorkflowListQuery(shopId);
	const invalidateWorkflowQuery = useInvalidateWorkflowQuery({
		shopId,
		workflowId,
	});
	return useMutation({
		mutationFn: async ({
			body,
			workflowId,
		}: {
			body: { isActive: boolean };
			workflowId: string;
		}) => {
			return mutation.mutateAsync({
				params: { path: { shopId, workflowId } },
				body: {
					status: body.isActive ? "ACTIVE" : "INACTIVE",
				},
			});
		},
		onError: () => {},
		onSuccess: () => {
			invalidateWorkflowQuery();
			invalidateWorkflowListQuery();
		},
	});
}
